import React, { useMemo } from "react";
import { useStyles } from "styling/mainStyles";
import { Box, Container } from "@material-ui/core";
import { LanguageList } from "components/common";

const Footer = () => {
  const classes = useStyles();
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <Container className={classes.footerContainer} maxWidth="md">
      <Box className="top-row">
        <LanguageList />
      </Box>
      {year} &copy; MyDailyBudget.com
    </Container>
  );
};

export default Footer;
